var _path, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup575(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4987 69.1333L39.3033 55.4083H21.6941L30.4987 69.1333Z",
    fill: "#0D0C22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.25,
    fill: "#0D0C22",
    stroke: "#0D0C22",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3638 39.5909C26.3638 41.4738 24.8375 43 22.9547 43C21.0719 43 19.5457 41.4738 19.5457 39.5909C19.5457 37.7081 21.0719 36.1819 22.9547 36.1819C24.8375 36.1819 26.3638 37.7081 26.3638 39.5909Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4092 39.5909C43.4092 41.4738 41.883 43 40.0001 43C38.1173 43 36.5911 41.4738 36.5911 39.5909C36.5911 37.7081 38.1173 36.1819 40.0001 36.1819C41.883 36.1819 43.4092 37.7081 43.4092 39.5909Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4156 30.0975L40.4008 24.084C40.1793 23.8613 39.7441 23.6818 39.4315 23.6818H35.4543V19.1364C35.4543 18.5091 34.9463 18 34.318 18H16.1364C15.5081 18 15 18.5091 15 19.1364V38.4543C15 39.0816 15.5081 39.5907 16.1364 39.5907H18.4091C18.4091 37.0793 20.4444 35.0453 22.9545 35.0453C25.4646 35.0453 27.4999 37.0793 27.4999 39.5907H35.4543C35.4543 37.0793 37.4896 35.0453 39.9997 35.0453C42.5098 35.0453 44.5451 37.0793 44.5451 39.5907H45.6815C46.3098 39.5907 46.8178 39.0816 46.8178 38.4543V31.068C46.8178 30.7545 46.6382 30.3203 46.4155 30.0976L46.4156 30.0975ZM43.4088 31.6362H36.5907V25.9544H38.8634L43.4088 30.4998V31.6362Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup575);
export default __webpack_public_path__ + "static/media/Group 575.f1dcff4a4809fd29a765d956461c54a1.svg";
export { ForwardRef as ReactComponent };